module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_OpenLoop_00182.3bc35fc6.png";